<template>
  <div>
    <div class="banner1">
      <div class="headNav">
        <div style="display: flex">
          <div :class="navIndex == 1 ? 'navBox navActive' : 'navBox'" @click="navBar(1)">个人资料</div>
          <div :class="navIndex == 4 ? 'navBox navActive' : 'navBox'" @click="navBar(4)">报名资料</div>
          <!-- <div :class="navIndex == 2 ? 'navBox navActive' : 'navBox'" @click="navBar(2)">修改手机</div> -->
          <div :class="navIndex == 3 ? 'navBox navActive' : 'navBox'" @click="navBar(3)">修改密码</div>
          <!-- <div :class="navIndex == 4 ? 'navBox navActive' : 'navBox'"
               @click="navBar(4)">寄送地址</div> -->
        </div>

        <div class="tipsRight">* 为必填选项</div>
      </div>

      <div class="tabBox" v-if="navIndex == 1">
        <div>
          <div class="up" style="width: 390px">
            <div><span style="color: #f56c6c; margin-right: 4px">*</span>头像</div>
            <div class="upImg">
              <div class="up1" :key="keyFag">
                <img v-if="form.userphoto == '' || !form.userphoto" src="../../../assets/listImgs/card.png" alt="" />
                <el-image class="idImg" v-else :src="form.userphoto" :preview-src-list="[form.userphoto]" alt="" />
              </div>
              <div class="up2">
                <div>
                  照片要求
                  <div>1、JPG、JPEG、PNG格式</div>
                  <div>2、文件小于2M，推荐413*295像素</div>
                  <div>
                    <el-upload
                      class="upload-demo"
                      :action="uploadUrl"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :headers="headers"
                    >
                      <el-button class="upBtn">上传照片</el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="form.userphoto == '' || !form.userphoto" class="tips" style="right: 128px">请上传证件照！</div>
          </div>
        </div>
        <div class="formBox">
          <el-form :model="form" label-position="left" :rules="rules" ref="ruleForm" label-width="102px" class="demo-ruleForm">
            <el-row>
              <el-col :span="8">
                <el-form-item label="您的姓名：" prop="realName">
                  <el-input disabled style="width: 210px" v-model="form.realName" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证号：" prop="cardNo">
                  <el-input disabled style="width: 210px" v-model="form.cardNo" placeholder="请输入身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系方式：" prop="mobile">
                  <el-input style="width: 210px" v-model="form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="8">
                <el-form-item label="您的学历：" prop="degree">
                  <el-select v-model="form.degree" placeholder="请选择学历">
                    <el-option v-for="item in academicList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="公司名称：" prop="organization">
                  <el-input style="width: 210px" v-model="form.organization" placeholder="请输入公司名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="display: flex; margin-top: 43px">
          <div class="up">
            <div><span style="color: #f56c6c; margin-right: 4px"></span>身份证人像面(如在线下提交了身份证可不上传)</div>
            <div class="c1" :key="keyFag1">
              <img v-if="form.idCardFrontImage == '' || !form.idCardFrontImage" src="../../../assets/listImgs/face.png" alt="" />
              <el-image
                style="width: 100%; height: 100%"
                :preview-src-list="[form.idCardFrontImage]"
                class="allImage"
                v-else
                :src="form.idCardFrontImage"
                alt=""
              />
            </div>
            <div style="width: 237px; display: flex; justify-content: center">
              <div>
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess1"
                  :before-upload="beforeAvatarUpload"
                  :headers="headers"
                >
                  <el-button class="upBtn">上传照片</el-button>
                </el-upload>
              </div>
            </div>
          </div>

          <div class="up" style="margin-left: 199px">
            <div><span style="color: #f56c6c; margin-right: 4px"></span>身份证国徽面</div>
            <div class="c1" :key="keyFag2">
              <img v-if="form.idCardBackImage == '' || !form.idCardBackImage" src="../../../assets/listImgs/back.png" alt="" />
              <el-image
                style="width: 100%; height: 100%"
                :preview-src-list="[form.idCardBackImage]"
                class="allImage"
                v-else
                :src="form.idCardBackImage"
                alt=""
              />
            </div>
            <div style="width: 237px; display: flex; justify-content: center">
              <div>
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess2"
                  :before-upload="beforeAvatarUpload"
                  :headers="headers"
                >
                  <el-button class="upBtn">上传照片</el-button>
                </el-upload>
              </div>
            </div>
          </div>
        </div>

        <div class="suBtn" @click="submitForm">确认提交</div>
      </div>

      <div class="tabBox" style="display: flex; justify-content: center" v-if="navIndex == 2">
        <div class="phone" style="width: 300px; align-items: flex-start; height: 400px">
          <div style="font-size: 16px; color: #333333">原手机号:</div>
          <div class="xgsj1_old_code">
            <input type="text" class="codeBox" style="width: 300px" v-model="codeQuerty.orderMobile" placeholder="请输入旧手机号码" />
          </div>
          <div class="xgsj1_old_code" style="display: flex; align-items: center">
            <input type="text" placeholder="请输入图形验证码" v-model="codeQuerty.imgCode" class="codeBox" style="width: 150px" />

            <img
              style="height: 44px; width: 130px; margin-top: 12px; margin-left: 20px; cursor: pointer"
              @click="getImgCode"
              :src="codeImg"
              alt="安全生产学习平台"
            />
          </div>
          <div class="xgsj1_old_code">
            <input type="text" placeholder="请输入验证码" v-model="codeQuerty.mobileCode" class="codeBox" style="width: 150px" />

            <el-button class="codeBtn" @click="getCode1" v-if="!isCounting" style="line-height: 20px; width: 130px">
              {{ buttonText }}
            </el-button>
            <el-button class="codeBtn" v-if="isCounting" style="line-height: 20px; width: 130px">{{ countdown }}s后重新发送 </el-button>
          </div>

          <div style="font-size: 16px; color: #333333; margin-top: 10px">新手机号:</div>
          <input type="text" class="codeBox" style="width: 300px" v-model="codeQuerty.mobile" placeholder="请输入新手机号码" />
          <div style="display: flex; justify-content: center">
            <el-button class="nax" @click="subNewPhone"> 确定 </el-button>
          </div>
        </div>
      </div>
      <!-- 3 -->
      <div class="tabBox" v-if="navIndex == 3">
        <div class="phone">
          <div>
            <div style="font-size: 16px; color: #333333; text-align: center">修改账号密码</div>
            <el-input type="text" class="xgsj1_old_num" v-model="psdInfo.oldPasswd" placeholder="请输入原密码" show-password />

            <div>
              <el-input type="text" class="xgsj1_old_num" placeholder="请输入新密码" v-model="psdInfo.newPasswd" show-password />
              <div style="font-size: 12px; margin-top: 5px; color: #ff8000">密码6-25个字符，区分大小写，不能包含中文和特殊字符</div>
            </div>

            <div><el-input type="text" class="xgsj1_old_num" placeholder="请确认密码" v-model="psdInfo.checkPasswd" show-password /></div>

            <div style="display: flex; justify-content: center">
              <el-button class="nax" @click="subPsd"> 保存 </el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 3 -->
      <div class="tabBox" v-if="navIndex == 4">
        <div class="formBox">
          <el-form :model="bmForm" label-position="left" label-width="102px" class="demo-ruleForm">
            <el-row>
              <el-col :span="8">
                <el-form-item label="培训科目：" prop="projectId">
                  <el-select v-model="projectId" placeholder="请选择" @change="getInfo">
                    <el-option
                      v-for="item in projectList"
                      :key="item.trainingSubjectId"
                      :label="item.trainingSubject"
                      :value="item.orderId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8" v-for="item in bmForm.applyDataUpdateVo" :key="item.configId">
                <el-form-item
                  label-width="135px"
                  v-if="item.fieldName == '政治面貌'"
                  :label="item.fieldName + ':'"
                  :prop="item.configId"
                  :rules="[{ required: true, message: '请选择' + item.fieldName, trigger: 'change' }]"
                >
                  <el-select :disabled="item.isCert == '02'" @change="handleCheckedChange" v-model="bmForm[item.configId]" :placeholder="'请选择' + item.fieldName">
                    <el-option label="党员" value="党员"></el-option>
                    <el-option label="群众" value="群众"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label-width="135px"
                  v-if="item.fieldName == '学位'"
                  :label="item.fieldName + ':'"
                  :prop="item.configId"
                  :rules="[{ required: true, message: '请选择' + item.fieldName, trigger: 'change' }]"
                >
                  <el-select :disabled="item.isCert == '02'"  @change="handleCheckedChange" v-model="bmForm[item.configId]" :placeholder="'请选择' + item.fieldName">
                    <el-option label="博士" value="博士"></el-option>
                    <el-option label="硕士" value="硕士"></el-option>
                    <el-option label="学士" value="学士"></el-option>
                    <el-option label="无" value="无"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label-width="135px"
                  v-if="item.fieldName == '岗位类别'"
                  :label="item.fieldName + ':'"
                  :prop="item.configId"
                  :rules="[{ required: true, message: '请选择' + item.fieldName, trigger: 'change' }]"
                >
                  <el-select :disabled="item.isCert == '02'"  @change="handleCheckedChange" v-model="bmForm[item.configId]" :placeholder="'请选择' + item.fieldName">
                    <el-option label="主要负责人" value="主要负责人"></el-option>
                    <el-option label="安全管理人员" value="安全管理人员"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label-width="135px"
                  v-if="item.fieldName == '单位类型'"
                  :label="item.fieldName + ':'"
                  :prop="item.configId"
                  :rules="[{ required: true, message: '请选择' + item.fieldName, trigger: 'change' }]"
                >
                  <el-select :disabled="item.isCert == '02'"  @change="handleCheckedChange" v-model="bmForm[item.configId]" :placeholder="'请选择' + item.fieldName">
                    <el-option label="金属非金属矿山(露天矿)" value="金属非金属矿山(露天矿)"></el-option>
                    <el-option label="金属非金属矿山(地下矿)" value="金属非金属矿山(地下矿)"></el-option>
                    <el-option label="陆上石油天然气开采" value="陆上石油天然气开采"></el-option>
                    <el-option label="危险化学品经营" value="危险化学品经营"></el-option>
                    <el-option label="危险化学品生产" value="危险化学品生产"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label-width="135px"
                  v-if="
                    item.fieldName !== '学位' &&
                    item.fieldName !== '政治面貌' &&
                    item.fieldName !== '岗位类别' &&
                    item.fieldName !== '单位类型'
                  "
                  :label="item.fieldName + ':'"
                  :prop="item.configId"
                  :rules="[{ required: true, message: '请输入' + item.fieldName, trigger: 'blur' }]"
                >
                  <el-input
                    :disabled="item.isCert == '02'" 
                    @input="handleCheckedChange"
                    style="width: 210px"
                    v-model="bmForm[item.configId]"
                    :placeholder="'请输入' + item.fieldName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <div style="display: flex; margin-top: 43px">
            <div class="up" style="width: 390px">
              <div><span style="color: #f56c6c; margin-right: 4px"></span>证件照</div>
              <div class="upImg">
                <div class="up1" :key="keyFag">
                  <img v-if="bmForm.idPhoto == '' || !bmForm.idPhoto" src="../../../assets/listImgs/card.png" alt="" />
                  <el-image class="idImg" v-else :src="bmForm.idPhoto" :preview-src-list="[bmForm.idPhoto]" alt="" />
                </div>
                <div class="up2">
                  <div>
                    照片要求
                    <div>1、JPG、JPEG、PNG格式</div>
                    <div>2、文件小于2M，推荐413*295像素</div>
                    <div>
                      <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :headers="headers"
                      >
                        <el-button class="upBtn">上传照片</el-button>
                      </el-upload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="up" style="margin-left: 199px">
              <div>
                学历证明或电子证书<span style="font-size: 13px; color: #979797"
                  >（手机与证书平行拍照，毕业证和户口选其中一个进行上传）</span
                >
              </div>
              <div class="c1" :key="keyFag2" style="display: flex; justify-content: center; align-items: center">
                <img v-if="bmForm.diploma == '' || !bmForm.diploma" src="../../../assets/listImgs/cearm.png" alt="" />
                <el-image
                  style="width: 100%; height: 100%"
                  :preview-src-list="[bmForm.diploma]"
                  class="allImage"
                  v-else
                  :src="bmForm.diploma"
                  alt=""
                />
              </div>
              <div style="width: 237px; display: flex; justify-content: center">
                <div>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess3"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers"
                  >
                    <el-button class="upBtn">上传照片</el-button>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>

          <div style="display: flex; margin-top: 43px" v-if="bmForm.trainType == '02'">
            <div class="up">
              <!-- <div v-if="bmForm.operatingLicense == '' || !bmForm.operatingLicense" class="tips">请上传操作证正面！</div> -->
              <div><span style="color: #f56c6c; margin-right: 4px">*</span>操作证正面</div>
              <div class="c1" :key="keyFag1">
                <img v-if="bmForm.operatingLicense == '' || !bmForm.operatingLicense" src="../../../assets/listImgs/face.png" alt="" />
                <el-image
                  style="width: 100%; height: 100%"
                  :preview-src-list="[bmForm.operatingLicense]"
                  class="allImage"
                  v-else
                  :src="bmForm.operatingLicense"
                  alt=""
                />
              </div>
              <div style="width: 237px; display: flex; justify-content: center">
                <div>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess4"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers"
                  >
                    <el-button class="upBtn">上传照片</el-button>
                  </el-upload>
                </div>
              </div>
            </div>

            <!-- <div class="up" style="margin-left: 199px">
            <div v-if="form.idCardBackImage == '' || !form.idCardBackImage" class="tips">请上传健康承诺书签名！</div>
            <div><span style="color: #f56c6c; margin-right: 4px">*</span>健康承诺书签名</div>
            <div class="c1" :key="keyFag2">
              <img v-if="form.idCardBackImage == '' || !form.idCardBackImage" src="../../../assets/listImgs/back.png" alt="" />
              <el-image
                style="width: 100%; height: 100%"
                :preview-src-list="[form.idCardBackImage]"
                class="allImage"
                v-else
                :src="form.idCardBackImage"
                alt=""
              />
            </div>
            <div style="width: 237px; display: flex; justify-content: center">
              <div>
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess2"
                  :before-upload="beforeAvatarUpload"
                  :headers="headers"
                >
                  <el-button class="upBtn">上传照片</el-button>
                </el-upload>
              </div>
            </div>
          </div> -->
          </div>
          <div class="suBtn" @click="submitBmForm">确认提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import { getUserDetail, doUpdatePerson, toPersonalCenter, getMaterials, doSaveMaterials } from '@/api/submitForm.js';
import { getEducationList, toGenerateOrder } from '@/api/courseSelection.js';
import { getUser, getTitleList, doUpdateUserPasswd, updateUser, checkCode, doUpdateMobile } from '@/api/study.js';
import { addUserAddress, updateUserAddress } from '@/api/cert.js';
import { captchaImage, sendDx, getAllAreaList } from '@/api/regist.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      navIndex: 1, //切换
      imageUrl: '',
      form: {},
      userInfo: {
        userName: '',
        cardno: '',
        realname: '',
        sex: '',
        bindMobile: '',
        imgCode: '',
        email: '',
        phone: '',
        yzm: '',
        userAddress: '',
        organization: '',
        area: '',
        address: '',
        title: '',
        degree: ''
      }, //用户信息
      optionsArea: [],
      upImg: '',
      props: {
        value: 'CODEID',
        label: 'CITYNAME'
      },
      props1: {
        value: 'CODE_NO',
        label: 'CODE_NAME'
      },
      uploadUrl: window.glob.baseURL + '/common/upload', // 上传的图片服务器地址
      countdown: 60, // 默认倒计时为30秒
      buttonText: '获取验证码', // 按钮文字
      isCounting: false, // 标记是否正在进行倒计时
      zcList: [], //职称list
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '手机号不符合规则！', trigger: 'blur' }
        ],
        // area: [{ required: true, message: '请选择区域', trigger: 'change' }],
        address: [{ min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }],
        postcode: [{ required: true, message: '请输入邮政编码！', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        cardno: [{ required: true, message: '请输入身份证', trigger: 'blur' }],
        realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        // bindMobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        organization: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
          { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }
        ],
        // email: [
        //   { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        //   { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        // ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        area: [{ required: true, message: '请选择地区', trigger: 'change' }],
        title: [{ required: true, message: '请选择职称', trigger: 'change' }]
      },
      codeQuerty: {}, //验证码
      phoneNext: false,
      codeImg: '',
      uuid: '',
      psdInfo: {},
      timer: null,
      addDialogVisible: false,
      UpdataDialogVisible: false,
      Updatarules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '手机号不符合规则！', trigger: 'blur' }
        ],
        area: [{ required: true, message: '请选择区域', trigger: 'change' }],
        address: [
          { required: true, message: '请输入详细地址！', trigger: 'blur' },
          { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }
        ],
        postcode: [{ required: true, message: '请输入邮政编码！', trigger: 'blur' }]
      },
      optionsArea: [],
      ruleForm: {},
      UpdataForm: {},
      ressList: [],

      num: 1,
      check: false,
      bindMobileShow: false, //是否可以修改手机号
      form: {},
      rules: {
        projectId: [{ required: true, message: '请选择培训科目', trigger: 'change' }],
        realName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        cardNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度在 18 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
        ],
        degree: [{ required: true, message: '请选择学历', trigger: 'change' }],
        organization: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度必须大于2个字符', trigger: 'blur' }
        ],
        desiredTrainDate: [{ required: true, message: '请选择参加面授班培训日期', trigger: 'change' }]
      },
      fileList: [],
      uploadUrl: window.glob.baseURL + '/common/upload', // 上传的图片服务器地址
      headers: {},
      keyFag: 123,
      keyFag1: 234,
      keyFag2: 567,
      keyFag3: 9023,
      keyFag4: 21321,
      academicList: [], //学历
      projectId: '',
      projectList: [],
      bmForm: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //更改获取报名资料
    getInfo(id) {
      getMaterials({ orderId: id }).then(res => {
        this.bmForm = res.data.data;
        this.bmForm.applyDataUpdateVo.forEach(v => {
          this.bmForm[v.configId] = v.fieldValue;
        });
      });
    },
    //提交修改个人资料
    submitForm() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          // if (this.form.userphoto == '' || this.form.userphoto == undefined) {
          //   this.$message('请上传证件照！');
          //   return false;
          // }
          // if (this.form.idCardFrontImage == '' || this.form.idCardFrontImage == undefined) {
          //   this.$message('请上传身份证人像面！');
          //   return false;
          // }
          // if (this.form.idCardBackImage == '' || this.form.idCardBackImage == undefined) {
          //   this.$message('请上传身份证国徽面！');
          //   return false;
          // }
          // this.form.orderId = '';
          doUpdatePerson(this.form).then(res => {
            if (res.data.code == '200') {
              this.$message({
                type: 'success',
                message: '修改个人资料成功！'
              });
              // 使用 update:propName 模式触发更新
            }
            this.getUserDetail();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //提交修改报名资料
    submitBmForm() {
     
      this.bmForm.orderId = this.projectId;
      const sysEnrollmentUserApplyVos = {};
      for (const [key, value] of Object.entries(this.bmForm)) {
        if (key.length == 32) {
          sysEnrollmentUserApplyVos[key] = value;
        }
      }
      this.bmForm.sysEnrollmentUserApplyVos = sysEnrollmentUserApplyVos;
      doSaveMaterials(this.bmForm).then(res => {
        if (res.data.code == '200') {
          this.$message({
            type: 'success',
            message: '修改报名资料成功！'
          });
        }
      });
    },
    //获取个人资料
    getUserDetail() {
      getUserDetail({}).then(res => {
        console.log(res, 111111);
        this.form = res.data.data;
        this.$emit('update:avatar', res.data.data.userphoto);
      });
    },
    //获取学历
    getEducationList() {
      getEducationList().then(res => {
        console.log(res.data.data);
        this.academicList = res.data.data;
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/jpeg';
      const iPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isJPG || iPNG) {
      } else {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || iPNG) && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      this.form.userphoto = res.url;
      this.bmForm.idPhoto = res.url;
      this.keyFag = this.keyFag + 1;
    },
    handleAvatarSuccess1(res, file) {
      this.form.idCardFrontImage = res.url;
      this.keyFag1 = this.keyFag + 1;
    },
    handleAvatarSuccess2(res, file) {
      this.form.idCardBackImage = res.url;
      this.keyFag2 = this.keyFag + 1;
    },
    handleAvatarSuccess3(res, file) {
      this.bmForm.diploma = res.url;
      this.keyFag2 = this.keyFag + 1;
    },
    handleAvatarSuccess4(res, file) {
      this.bmForm.operatingLicense = res.url;
      this.keyFag2 = this.keyFag + 1;
    },
    handleCheckedChange() {
      // 点击后参数已经发生变化，重新渲染
      this.$forceUpdate();
    },
    updataAddres(row) {
      this.UpdataForm = row;
      this.check = this.UpdataForm.isdefault == '02' ? true : false;
      console.log(this.UpdataForm);
      this.num = this.num + 1;
      this.UpdataDialogVisible = true;
      getAllAreaList({}).then(res => {
        this.optionsArea = res.data.data;
      });
    },

    //确定修改
    updataResss(formName) {
      if (!Array.isArray(this.UpdataForm.area)) {
        this.UpdataForm.area = [this.UpdataForm.area];
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.UpdataForm.area = this.UpdataForm.area[this.UpdataForm.area.length - 1];
          this.UpdataForm.isdefault = this.check == true ? '02' : '01';
          updateUserAddress(this.UpdataForm).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功!',
              duration: 800
            });
            this.UpdataDialogVisible = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //确定添加
    addresss(formName) {
      if (!Array.isArray(this.ruleForm.area)) {
        this.$message.error('请选择地区！');
        return false;
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.area = this.ruleForm.area[this.ruleForm.area.length - 1];
          this.ruleForm.isdefault = this.ruleForm.isdefault == true ? '02' : '01';
          addUserAddress(this.ruleForm).then(res => {
            console.log(res.data);
            this.addDialogVisible = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //添加地址弹框
    address() {
      this.addDialogVisible = true;
      this.ruleForm = {};
      getAllAreaList({}).then(res => {
        this.optionsArea = res.data.data;
      });
    },
    //修改密码
    subPsd() {
      if (!this.psdInfo.oldPasswd) {
        this.$message.error('请输入原密码！');
        return false;
      }
      if (!this.psdInfo.newPasswd) {
        this.$message.error('请输入新密码！');
        return false;
      }
      if (this.psdInfo.newPasswd.length < 6) {
        this.$message.error('新密码最少为6位！');
        return false;
      } else if (this.psdInfo.newPasswd.length > 25) {
        this.$message.error('新密码最大为25位！');
        return false;
      }
      if (!this.psdInfo.checkPasswd) {
        this.$message.error('请输入确认密码');
        return false;
      }
      if (this.psdInfo.newPasswd !== this.psdInfo.checkPasswd) {
        this.$message.error('两次输入密码不一致！');
        return false;
      }
      doUpdateUserPasswd(this.psdInfo).then(res => {
        console.log(res.data);
        if (res.data.code == '500') {
          this.$message({
            message: res.data.msg,
            type: 'warning',
            duration: 800
          });
        } else {
          this.$message({
            message: '修改密码成功！',
            type: 'success',
            duration: 800
          });
          this.navIndex = 1;
        }
      });
    },
    //新手机号修改
    subNewPhone() {
      if (this.codeQuerty.orderMobile == '') {
        this.$message.error('请先输入原手机号', 1500);
        return false;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.codeQuerty.orderMobile)) {
        this.$message.error('请输入正确的手机号', 1500);
        return;
      }
      if (this.codeQuerty.imgCode == '') {
        this.$message.error('请先输入图形验证码', 1500);
        return false;
      }
      if (this.codeQuerty.mobileCode == '') {
        this.$message.error('请先输入短信验证码', 1500);
        return false;
      }
      if (this.codeQuerty.mobile == '') {
        this.$message.error('请先输入新手机号', 1500);
        return false;
      }
      if (!phoneRegex.test(this.codeQuerty.mobile)) {
        this.$message.error('请输入正确的新手机号', 1500);
        return;
      }
      // this.codeQuerty.logo = this.uuid;
      const data = {
        oldMobile: this.codeQuerty.orderMobile,
        mobileCode: this.codeQuerty.mobileCode,
        mobile: this.codeQuerty.mobile,
        logo: this.uuid
      };
      doUpdateMobile(data).then(res => {
        console.log(res.data.data.code);
        if (res.data.data.code == '20') {
          this.$message({
            message: '修改手机号成功！',
            type: 'success',
            duration: 800
          });
          this.navIndex = 1;
          getUser().then(res => {
            this.userInfo = res.data.data;
          });
        } else {
          this.$message.error(res.data.data.msg);
          clearInterval(this.timer);
          this.resetButtonState();
        }
      });
    },
    //获取图片验证码
    getImgCode() {
      captchaImage().then(res => {
        this.codeImg = 'data:image/png;base64,' + res.data.img;
        this.uuid = res.data.uuid;
      });
    },
    getCode2() {
      let query = {
        bindMobile: this.userInfo.bindMobile
        // imgCode: this.userInfo.imgCode,
        // logo: this.uuid
      };
      if (this.userInfo.bindMobile !== '' || this.userInfo.bindMobile !== undefined) {
        var re = /^1\d{10}$/;
        if (!re.test(this.userInfo.bindMobile)) {
          this.$message.error('手机号码格式不正确！');
          return false;
        }
      }
      sendDx(query).then(res => {
        console.log(res);
        if (res.data.data.code == 1) {
          //倒计时逻辑
          if (!this.isCounting) {
            this.startCountDown();
            // 这里可以写发送验证码的逻辑
            console.log('发送验证码');
          }
        } else {
          this.$message({
            message: res.data.data.msg,
            type: 'warning'
          });
          // this.getImgCode();
          return false;
        }
      });
    },
    //获取新手机号验证码
    getCode1() {
      if (!this.codeQuerty.orderMobile) {
        this.$message.error('请先输入原手机号', 1500);
        return;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.codeQuerty.orderMobile)) {
        this.$message.error('请输入正确的手机号', 1500);
        return;
      }
      if (!this.codeQuerty.imgCode) {
        this.$message.error('请先输入图形验证码！');
        return false;
      }

      let query = {
        mobile: this.codeQuerty.orderMobile,
        imgCode: this.codeQuerty.imgCode,
        logo: this.uuid
      };

      sendDx(query).then(res => {
        console.log(res);
        if (res.data.data.code == 1) {
          //倒计时逻辑
          if (!this.isCounting) {
            this.startCountDown();
            // 这里可以写发送验证码的逻辑
            console.log('发送验证码');
          }
        } else {
          this.$message({
            message: res.data.data.msg,
            type: 'warning',
            duration: 800
          });
          this.getImgCode(); // 重新获取图形验证码
          return false;
        }
      });
    },
    //获取手机短信
    getCode() {
      let query = {
        bindMobile: this.userInfo.bindMobile
      };
      if (this.userInfo.bindMobile !== '' || this.userInfo.bindMobile !== undefined) {
        var re = /^1\d{10}$/;
        if (!re.test(this.userInfo.bindMobile)) {
          this.$message.error('手机号码格式不正确！');
          return false;
        }
      }
      sendDx(query).then(res => {
        console.log(res);
        if (res.data.data.code == 1) {
          //倒计时逻辑
          if (!this.isCounting) {
            this.startCountDown();
            // 这里可以写发送验证码的逻辑
            console.log('发送验证码');
          }
        } else {
          this.$message({
            message: res.data.data.msg,
            type: 'warning'
          });
          return false;
        }
      });
    },
    startCountDown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);

          this.resetButtonState();
        }
      }, 1000);

      this.isCounting = true;
    },
    resetButtonState() {
      this.isCounting = false;
      this.countdown = 60;
      this.buttonText = '获取验证码';
    },
    //切换
    navBar(id) {
      this.codeQuerty = {};
      this.navIndex = id;
      this.phoneNext = false;
      this.isCounting = false;
      this.countdown = 60;
      this.buttonText = '获取验证码';
      clearInterval(this.timer);
      this.psdInfo = {};

      // 当点击修改手机号时，获取图形验证码
      if (id === 2) {
        this.getImgCode();
      }
      if (id == 4) {
        this.projectList = [];
        toPersonalCenter({ trainSubjectId: '' }).then(res => {
          console.log(res.data.data.trainStudentInfoVo, '123');
          if (res.data.data.trainStudentInfoVo) {
            let arr = [
              {
                trainingSubject: res.data.data.trainStudentInfoVo.trainingSubject,
                trainingSubjectId: res.data.data.trainStudentInfoVo.trainingSubjectId,
                orderId: res.data.data.trainStudentInfoVo.orderId
              }
            ];

            this.projectList = [...arr, ...res.data.data.trainStudentInfoVo.trainingSubjectList];
            console.log(this.projectList);
            this.projectId = this.projectList[0].orderId;
            this.getInfo(this.projectList[0].orderId);
          } else {
            this.bmForm = res.data.data;
          }
        });
      }
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/jpeg';
      const iPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isJPG || iPNG) {
      } else {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || iPNG) && isLt2M;
    },
    getToken() {
      this.headers = {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      };
    },

    validateMobile(phone) {
      // 最新号段正则（2024年有效）
      const reg = /^(?:(?:\+|00)86)?1(?:(?:3[\d]|4[5-79]|5[0-35-9]|6[5-7]|7[0-8]|8[\d]|9[189])\d{8}$)/;
      return reg.test(String(phone).trim());
    },
    validateLandline(tel) {
      // 匹配格式示例：010-12345678、075512345678、12345678（无区号）
      const reg = /^(0\d{2,3}-)?\d{7,8}$/;
      return reg.test(String(tel).trim());
    },
    getUser() {
      // getUser().then(res => {
      //   this.userInfo = res.data.data;
      //   if (this.userInfo.bindMobile == null) {
      //     this.bindMobileShow = false;
      //     // this.getImgCode();
      //   } else {
      //     this.bindMobileShow = true;
      //   }
      // });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getToken();
    this.getUserDetail();
    this.getEducationList();
    window.scrollTo(0, 0);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.suBtn {
  margin: 58px auto;
  width: 180px;
  height: 48px;
  background: #3172f6;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #3172f6;
  text-align: center;
  line-height: 48px;
  color: #fff;
  cursor: pointer;
}
.code {
  width: 80px;
  height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
}
.codeBtn {
  width: 110px;
  height: 40px;
  border: 1px solid #2878ff;
  opacity: 1;
  font-size: 14px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  color: #2878ff;
  cursor: pointer;
  margin-left: 10px;
  background: #fff;
  line-height: 40px;
}
.updataImg {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  height: 141px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 141px;
  line-height: 141px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 141px;
  display: block;
}

.in {
  width: 200px;
}
.banner1 {
  width: 1170px;
  background: #fff;
  padding: 10px 40px;
  padding-bottom: 100px;
  border-radius: 6px;
  min-height: 748px;
  .headNav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #eee;
    font-weight: bold;
    .navBox {
      width: 80px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      font-size: 18px;
      margin-right: 42px;
      color: #666666;
      cursor: pointer;
    }
    .navActive {
      border-bottom: 2px solid #2878ff;
      color: #2878ff;
    }
    .tipsRight {
      color: #ff0000;
      font-size: 14px;
      line-height: 55px;
      font-weight: 500;
    }
  }

  .tabBox {
    margin-top: 30px;
    font-size: 16px;
    min-height: 434px;
    color: #333333;
    box-sizing: border-box;
    .up {
      font-size: 16px;
      position: relative;
      .tips {
        position: absolute;
        right: 0px;
        transform: translateX(-50%);
        bottom: -20px;
        color: #f56c6c;
        font-size: 12px;
      }
      .upImg {
        margin-top: 13px;
        display: flex;
        .up1 {
          cursor: pointer;
          width: 120px;
          height: 168px;
          background: #f4f6fa;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #efefef;
          display: flex;
          justify-content: center;
          align-items: center;
          .idImg {
            width: 120px;
            height: 168px;
          }
        }
        .up2 {
          margin-left: 30px;
          width: 240px;
          font-size: 14px;
          color: #666;
        }
      }
      .c1 {
        margin-top: 13px;
        cursor: pointer;
        width: 237px;
        height: 140px;
        background: #f4f6fa;
        border-radius: 4px 4px 4px 4px;
      }
      .upBtn {
        padding: 0 !important;
        margin-top: 12px;
        cursor: pointer;
        width: 92px;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #3172f6;
        color: #3172f6;
        font-size: 14px;
        text-align: center;
        line-height: 32px;
      }
      .c2 {
        margin-top: 13px;
        cursor: pointer;
        width: 237px;
        height: 140px;
        background: #f8f9fb;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #efefef;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .sxbBox {
        display: flex;
        flex-wrap: wrap;
        margin-top: 13px;
        .s1 {
          width: 420px;
          height: 90px;
          background: #f4f6fa;
          border-radius: 4px 4px 4px 4px;
          display: flex;
          align-items: center;
          padding: 20px 20px 20px 34px;
          margin-right: 40px;
          cursor: pointer;
          .yuan {
            width: 20px;
            height: 20px;
            background: #3172f6;
            border-radius: 50%;
            line-height: 20px;
            text-align: center;
          }

          .noYuan {
            width: 20px;
            height: 20px;
            border: 1px solid #979797;
            border-radius: 50%;
            line-height: 20px;
            text-align: center;
          }
        }
        .yActive {
          background: rgba(49, 114, 246, 0.1) !important;
          border: 1px solid #3172f6;
        }
        .s2 {
          margin-left: 20px;
          font-size: 16px;
          .s3 {
            color: #888888;
          }
        }
      }
    }
    .formBox {
      margin-top: 45px;
      .xu {
        border-bottom: 1px dashed #d4d6db;
      }
      .updataBox {
        padding-top: 40px;
        .up {
          font-size: 16px;
          position: relative;
          .tips {
            position: absolute;
            right: 107px;
            transform: translateX(-50%);
            bottom: 0px;
            color: #f56c6c;
            font-size: 12px;
          }
          .upImg {
            margin-top: 13px;
            display: flex;
            .up1 {
              cursor: pointer;
              width: 120px;
              height: 168px;
              background: #f4f6fa;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #efefef;
              display: flex;
              justify-content: center;
              align-items: center;
              .idImg {
                width: 120px;
                height: 168px;
              }
            }
            .up2 {
              margin-left: 30px;
              width: 240px;
              font-size: 14px;
              color: #666;
            }
          }
          .c1 {
            margin-top: 13px;
            cursor: pointer;
            width: 237px;
            height: 140px;
            background: #f4f6fa;
            border-radius: 4px 4px 4px 4px;
          }
          .upBtn {
            padding: 0 !important;
            margin-top: 12px;
            cursor: pointer;
            width: 92px;
            height: 32px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #3172f6;
            color: #3172f6;
            font-size: 14px;
            text-align: center;
            line-height: 32px;
          }
          .c2 {
            margin-top: 13px;
            cursor: pointer;
            width: 237px;
            height: 140px;
            background: #f8f9fb;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #efefef;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .sxbBox {
            display: flex;
            flex-wrap: wrap;
            margin-top: 13px;
            .s1 {
              width: 420px;
              height: 90px;
              background: #f4f6fa;
              border-radius: 4px 4px 4px 4px;
              display: flex;
              align-items: center;
              padding: 20px 20px 20px 34px;
              margin-right: 40px;
              cursor: pointer;
              .yuan {
                width: 20px;
                height: 20px;
                background: #3172f6;
                border-radius: 50%;
                line-height: 20px;
                text-align: center;
              }

              .noYuan {
                width: 20px;
                height: 20px;
                border: 1px solid #979797;
                border-radius: 50%;
                line-height: 20px;
                text-align: center;
              }
            }
            .yActive {
              background: rgba(49, 114, 246, 0.1) !important;
              border: 1px solid #3172f6;
            }
            .s2 {
              margin-left: 20px;
              font-size: 16px;
              .s3 {
                color: #888888;
              }
            }
          }
        }
      }
      .subBtn {
        cursor: pointer;
        margin: 60px auto auto auto;
        width: 180px;
        height: 48px;
        background: #3172f6;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #3172f6;
        color: #fff;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
      }
    }
    .userInfo {
      margin-top: 44px;
      .submitBtn {
        width: 200px;
        background: #2878ff;
        border-radius: 4px;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }

    .phone {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .xgsj1_old_num {
        border: 0;
        margin-top: 35px;
        outline: none;
        width: 300px;
        height: 44px;
        border-radius: 4px;
      }
      .codeBox {
        outline: none;
        padding-left: 20px;
        border: 0;
        width: 170px;
        height: 44px;
        background: #f4f5f7;
        opacity: 1;
        margin-top: 15px;
      }
      .codeBtn {
        width: 110px;
        height: 44px;
        border: 1px solid #2878ff;
        opacity: 1;
        margin-top: 15px;
        line-height: 44px;
        font-size: 14px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        color: #2878ff;
        cursor: pointer;
        margin-left: 20px;
        background: #fff;
      }
      .nax {
        width: 300px;
        background: #2878ff;
        opacity: 1;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        height: 44px;
        color: #fff;
        cursor: pointer;
        margin-top: 30px;
      }
    }
  }
}
</style>
